<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row dense>
      <v-col cols="12" sm="12" md="6" v-if="user.tipo == 'ADMIN'">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaProfessores(empresaSelecionada)"
          hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <v-autocomplete
          outlined
          dense
          v-model="professorSelecionado"
          :items="professores"
          item-text="nome"
          item-value="id"
          label="Selecione o professor"
          @input="carregaGrafico(user.tipo == 'ADMIN' ? empresaSelecionada : companyobj.id)"
          hide-details
        ></v-autocomplete>
      </v-col>
    </v-row>
    
    <v-row dense>
      <v-col cols="12" lg="2">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedInicio"
              label="Data Inicio"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedInicio)"
              v-on="on"
              outlined
              dense
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataInicio" no-title @input="menu1 = false" locale="pt-BR"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" lg="2">
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedFim"
              label="Data Fim"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedFim)"
              v-on="on"
              outlined
              dense
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataFim" no-title @input="menu2 = false" locale="pt-BR"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xs="12" sm="12" lg="3">
        <v-btn dark @click="carregaGrafico(user.tipo == 'ADMIN' ? empresaSelecionada : companyobj.id)" fab small color="#01579B" :disabled="professorSelecionado == ''">
          <v-icon>search</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" xs="12" sm="12" md="12" lg="6">
        <v-card style="padding: 15px; margin-bottom: 10px" flat height="200px" outlined>
          <VueSvgGauge
            :start-angle="-90"
            :end-angle="90"
            :value="parseFloat(graficoResultado.mediaAcelerometro)"
            :separator-step="1"
            :min="0"
            :max="10"
            :gauge-color="[{ offset: 0, color: '#B71C1C'},{ offset: 50, color: '#FFEA00'},{ offset: 100, color: '#1B5E20'}]"
            :scale-interval="1.0"
          />
        </v-card>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="12" lg="6">
        <v-card style="padding: 15px; margin-bottom: 10px; margin: 0 auto" flat height="200px" outlined>
          <h1 style="margin: 25px 50px 25px 50px">Média:</h1>
          <h1 style="margin: 25px 50px 25px 50px">{{ graficoResultado.mediaAcelerometro }}</h1>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-toolbar flat color="white" dense>
          <v-toolbar-title class="textoUser">RESULTADOS</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card flat style="border-radius: 0px" v-if="graficoResultado.carregamento == false">
          <apexchart
            type="line"
            height="200"
            width="100%"
            :options="graficoResultado.chartOptions"
            :series="graficoResultado.series"
            :key="graficoResultado.x"
          ></apexchart>
        </v-card>
        <v-card flat style="border-radius: 0px; margin: 0 auto" v-if="graficoResultado.carregamento == true" height="200">
          <v-row>
            <v-col cols="10" style="margin: 70px auto">
              <v-progress-linear indeterminate></v-progress-linear>
              <p style="margin: 10px; text-align: center; color: #666; font-size: 13px">Carregando dados...</p>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Aguarde, buscando resultados..."
        >
          <template slot="no-data">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" class="mt-4" icon="info">Nenhum resultado encontrado</v-alert>
              </v-col>
            </v-row>
          </template>
          <template slot="no-results">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.login`]="{ item }">
            <p style="margin: 0px" v-if="item.login">{{ formatDateHour(item.login) }}</p>
          </template>
          <template v-slot:[`item.logout`]="{ item }">
            <p style="margin: 0px" v-if="item.logout">{{ formatDateHour(item.logout) }}</p>
          </template>
          <template v-slot:[`item.notaAula`]="{ item }">
            <v-row dense v-if="item.logout && item.notaAula >= 1">
              <v-rating
                :color="item.notaAula < 9 ? 'red' : 'warning'"
                empty-icon="mdi-star-outline"
                full-icon="mdi-star"
                half-icon="mdi-star-half-full"
                half-increments
                length="5"
                size="20"
                :value="(item.notaAula / 2)"
                readonly
              ></v-rating>
              <p style="margin-bottom: 0px; margin-top: 8px; color: #aaa">({{ (item.notaAula) }})</p>
            </v-row>
            <p style="margin: 0px; color: #aaa" v-else-if="item.logout && item.notaAula == 0">Não avaliou</p>
            <p style="margin: 0px; color: #aaa" v-else>Aguardando finalizar para avaliar</p>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import { VueSvgGauge } from 'vue-svg-gauge'
  export default {
    components: { Snackbar, Loading, VueSvgGauge, },
    data: vm => ({
      isLoading: false,
      fullPage: true,
      empresas: [],
      empresaSelecionada: '',
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Aluno(a)', value: 'aluno.nome', align: 'start' },
          { text: 'Entrada', value: 'login' },
          { text: 'Saída', value: 'logout' },
          { text: 'Avaliação', value: 'notaAula' },
        ],
        carregamento: false,
        conteudo: [],
      },
      professores: [],
      professorSelecionado: '',
      date: new Date().toISOString().substring(0, 10),
      mask: "##:##:##",
      menu1: false,
      menu2: false,
      dateFormattedInicio: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10)),
      dateFormattedFim: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10)),
      dataInicio: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
      dataFim: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
      qtdDiasSelecionados: 0,
      graficoResultado: {
        carregamento: false,
        mediaAcelerometro: 0,
        x: 0,
        series: [{
          name: "",
          data: []
        }],
        chartOptions: {
          chart: {
            type: 'line',
            zoom: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: true
          },
          xaxis: {
            categories: [],
          }
        },
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      computedDateFormattedInicio () {
        return this.formatDate(this.dataInicio)
      },
      computedDateFormattedFim () {
        return this.formatDate(this.dataFim)
      },
    }),

    watch: {
      empresas() {
        this.empresaSelecionada = this.empresas[0].id
        this.carregaProfessores(this.empresaSelecionada)
      },

      dataInicio() {
        this.dateFormattedInicio = this.formatDate(this.dataInicio)
      },

      dataFim() {
        this.dateFormattedFim = this.formatDate(this.dataFim)
      },
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaProfessores(this.companyobj.id)
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaProfessores(empresaId) {
        this.professores = []
        this.isLoading = true

        await axios.get(baseApiUrl + 'Professores?filter={"where":{"empresaId":"' + empresaId + '"}, "order": "nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.professores = response.data
          }
          this.isLoading = false
        })
      },

      async carregaGrafico(empresaId) {
        let axisX = []
        this.graficoResultado.chartOptions.xaxis.categories = []
        this.graficoResultado.carregamento = true
        this.tabela.carregamento = true
        this.graficoResultado.series[0].data = []
        this.tabela.conteudo = []
        

        this.qtdDiasSelecionados = moment(this.dataFim).diff(this.dataInicio, 'days')

        for (let i = this.qtdDiasSelecionados; i >= 0; i--) {
          axisX.push(moment().subtract(i, 'day').format('DD/MM'))
        }

        await axios.get(baseApiUrl + 'ServicePaineis?filter={"where":{"and":[{"empresaId":"' + empresaId + '"},{"professorId":"' + this.professorSelecionado + '"},{"created":{"gt":"' + moment().subtract(this.qtdDiasSelecionados, 'day').format('YYYY-MM-DD').replace('-03:00', 'Z') + 'T00:00:00.000Z"}},{"created":{"lt":"' + moment().format('YYYY-MM-DD').replace('-03:00', 'Z') + 'T23:59:59.000Z"}}]}, "include":"aluno"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            for (let i = 0; i < axisX.length; i++) {
              let avaliacoesPorData = response.data.filter(avaliacao => avaliacao.notaAula > 0 && moment(avaliacao.created).format('DD/MM') == axisX[i])
              this.graficoResultado.chartOptions.xaxis.categories.push(axisX[i])
              this.graficoResultado.series[0].data.push(this.calculaMedia(avaliacoesPorData))
            }

            this.graficoResultado.mediaAcelerometro = this.calculaMedia(response.data)
            this.tabela.conteudo = response.data
            this.graficoResultado.carregamento = false
            this.tabela.carregamento = false
            this.graficoResultado.x++
          }
        })
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      calculaMedia(arr) {
        const notasValidas = arr.filter(obj => typeof obj.notaAula === 'number' && obj.notaAula > 0)

        if (notasValidas.length === 0) {
          return 0;
        }
        
        const soma = notasValidas.reduce((total, obj) => total + obj.notaAula, 0);
        const media = soma / notasValidas.length;
        
        return media.toString().substring(0, 3)
      },

      formatDateHour(data_hora) {
        let data = data_hora.substr(0, 10).split('-')
        data = data[2] + '/' + data[1] + '/' + data[0]
        let hora = data_hora.substr(11, 8)

        return data + ' às ' + hora
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
  
  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }
</style>